const ENTRY_SOURCE_KEY = "calendarEntrySource";

export const CALENDAR_ENTRY_SOURCE = {
  TEAMS: "teams",
  WEB: "web",
};

export function setCalendarEntrySource(source) {
  if (!source) {
    return;
  }

  sessionStorage.setItem(ENTRY_SOURCE_KEY, source);
}

export function getCalendarEntrySource() {
  return sessionStorage.getItem(ENTRY_SOURCE_KEY);
}

export function isTeamsCalendarEntry() {
  return getCalendarEntrySource() === CALENDAR_ENTRY_SOURCE.TEAMS;
}
